import React, {useState} from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {LawFooter} from './LawFooter';
import FooterBar from '../../_common/components/FooterBar';
import Tabs from "../../_common/components/Tabs";
import {TableAgents} from "./TableAgents";
import {TableTransactions} from "./TableTransactions";
import {shallowEqual, useSelector} from "react-redux";
import {LawAgentsFilters} from "./LawAgentsFilters";
import {LawTransactionsFilters} from "./LawTransactionsFilters";
import type {RootStateAgents, RootStateTransactions, RootStatePaid} from "../types";

export function LawCard() {
  const [activeTab, setActiveTab] = useState('agents');
  const {count: agentsCount} = useSelector(
    (state: RootStateAgents) => ({count: state.lawAgents.totalCount}),
    shallowEqual
  );
  const {count: transactionsCount} = useSelector(
    (state: RootStateTransactions) => ({count: state.lawTransactions.totalCount}),
    shallowEqual
  );
  const {totalPaid} = useSelector(
    (state: RootStatePaid) => ({totalPaid: state.lawTransactions.totalPaid}),
    shallowEqual
  );

  const footerValue = activeTab === 'agents'
    ? agentsCount
    : transactionsCount;
  const totalAmountValue = activeTab === 'agents'
    ? 0
    : totalPaid;

  return (
    // @ts-ignore
    <Card className={'flex-fill bg-transparent shadow-none'} id={'law-card'}>
      {activeTab === 'agents' ? <LawAgentsFilters/> : <LawTransactionsFilters/>}
      <Tabs
        setActiveTab={setActiveTab}
        // @ts-ignore
        items={[
          {
            key: 'agents',
            title: 'סוכנים',
            icon: <i className="flaticon2-user"/>,
            content: <TableAgents/>,
          },
          {
            key: 'transactions',
            title: 'עסקאות',
            icon: <i className="flaticon2-list"/>,
            content: <TableTransactions/>,
          },
        ]}
      />
      <FooterBar>
        <LawFooter value={footerValue} totalAmount={totalAmountValue}/>
      </FooterBar>
    </Card>
  );
}
